import { DiTokens } from "../../services/diTokens";
import IAlertService from "../../services/alert/IAlertService";
import IAuthService from "../../services/auth/IAuthService";
import { container } from "@/inversify.config";
import { BaseLoginModel } from "../../models/auth/BaseLoginModel";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import { ConfigStore } from "../../store/modules/config";
import { AppStore } from "../../store/modules/app";

/**Модель представления авторизации */
export class LoginVue extends Vue {
  /**Модель авторизации */
  public model: BaseLoginModel = new BaseLoginModel();

  /**Ссылка на службу авторизации */
  get authService(): IAuthService<BaseLoginModel> {
    return container.get<IAuthService<BaseLoginModel>>(DiTokens.AuthService);
  }

  /**Ссылка на службу уведомленний */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  /**Стор настроек */
  get appStore(): AppStore {
    return getModule(AppStore, this.$store);
  }

  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**Признак отображения пароля */
  showPassword: boolean = false;

  /**Признак отображения нового пароля */
  showNewPassword: boolean = false;

  /**Признак отображения подтверждения пароля  */
  showConfirmPassword: boolean = false;

  /**Признак отображения кода подтверждения */
  showConfirmCode: boolean = false;

  /**Признак валидности формы */
  valid: boolean = true;

  /**Ссылка на правила банка */
  get rulesFile(): string {
    return this.configStore.apiData.RulesFile;
  }

  /**Ссылка на тарифы банка */
  get tarifsFile(): string {
    return this.configStore.apiData.TarifsFile;
  }

  /**Валидация формы */
  validateForm(): void {
    console.log("validateForm");
  }

  /**Сброс результата валидации формы */
  resetFormValidation(): void {
    console.log("resetFormValidation");
  }

  /**Инициализация формы */
  async init() {
    this.model = await this.authService.init(null);
    this.loginHandler = () => this.loginHandlerF.apply(this);
  }

  /**Обработка сабмита формы */
  async loginHandlerF() {
    if (this.appStore.loading)
      return

    this.appStore.setLoading(true);

    this.valid = (this.$refs.form as Vue & { validate: () => boolean }).validate();

    if (!this.valid) {
      this.appStore.setLoading(false);
      return;
    }

    this.model = await this.authService.login(this.model);
    if (this.model.IsSuccess) {
      window.localStorage.setItem('loginValue', this.model.Login)
      this.alertService.clear();
      const returnUrl = this.$route.query.returnUrl || "/";
      this.$router.push(returnUrl);
    } else {
      this.appStore.setLoading(false);
      this.resetFormValidation();
    }
  }

  loginHandler: Function = () => '';

  /**Обработка нажатия назад */
  back() {
    this.alertService.clear();
    this.resetFormValidation();
    this.model._isChangePassword = false;
    this.model._isNeedConfirm = false;
    this.model.VerifyCode = "";
    this.model.NewPassword = "";
    this.model.ConfirmPassword = "";
  }
}
